import { render, staticRenderFns } from "./SendDocumentDetailTab.vue?vue&type=template&id=6d8039f8&scoped=true&lang=pug"
import script from "./SendDocumentDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendDocumentDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentDetailTab.vue?vue&type=style&index=0&id=6d8039f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8039f8",
  null
  
)

export default component.exports